import React from "react";
import { Trash2, RotateCcw } from "lucide-react";

const Empty = ({ children }) => <div className="border border-[#262421] px-5 py-8 text-center text-[#8A857D] text-sm">{children}</div>;

const filterMembers = (customers, search) => {
  const q = search.trim().toLowerCase();
  if (!q) return customers;
  return customers.filter((c) => `${c.name} ${c.email} ${c.phone}`.toLowerCase().includes(q));
};

const MemberStats = ({ c }) => {
  const items = [
    ["دخول", c.login_count, "#C49A6C"],
    ["خروج", c.logout_count, "#8A857D"],
    ["مشتريات", c.purchases, "#7F9E6B"],
    ["إلغاء", c.cancellations, "#C6553B"],
    ["الإنفاق", `AED ${Number(c.total_spent || 0).toLocaleString()}`, "#C49A6C"],
  ];
  return (
    <div className="grid grid-cols-2 sm:grid-cols-5 gap-3 text-center">
      {items.map(([label, val, color]) => (
        <div key={label} className="border border-[#262421] px-3 py-2 min-w-[64px]">
          <p className="text-[9px] uppercase tracking-wider text-[#6E685F]">{label}</p>
          <p className="serif text-lg mt-1" style={{ color }}>{val}</p>
        </div>
      ))}
    </div>
  );
};

const MemberAction = ({ c, onDelete, onRestore }) => (c.deleted ? (
  <button onClick={() => onRestore(c.id)} data-testid={`member-restore-${c.id}`} title="استرجاع العضو" className="flex items-center gap-1.5 border border-[#7F9E6B] text-[#7F9E6B] text-[10px] uppercase tracking-widest px-3 py-2 hover:bg-[#7F9E6B] hover:text-[#0B0A08] transition-colors self-center">
    <RotateCcw size={14} /> استرجاع
  </button>
) : (
  <button onClick={() => onDelete(c.id)} data-testid={`member-delete-${c.id}`} title="حذف العضو" className="text-[#8A857D] hover:text-[#C6553B] p-2 self-center transition-colors">
    <Trash2 size={17} />
  </button>
));

const MemberCard = ({ c, onDelete, onRestore }) => (
  <div className={`border p-5 ${c.deleted ? "border-[#3a2a2a] bg-[#140f0f] opacity-70" : "border-[#262421]"}`} data-testid={`member-${c.id}`}>
    <div className="flex flex-wrap justify-between gap-4 items-start">
      <div className="min-w-0">
        <div className="flex items-center gap-2">
          <p className="serif text-lg text-[#C49A6C]">{c.name || "—"}</p>
          {c.deleted && <span className="text-[9px] uppercase tracking-widest text-[#C6553B] border border-[#C6553B] px-2 py-0.5">محذوف</span>}
        </div>
        <p className="text-xs text-[#8A857D] mt-1 break-all">{c.email}</p>
        <p className="text-xs text-[#C9C0B4] mt-2"><span className="text-[#6E685F]">الهاتف: </span>{c.phone}</p>
        <p className="text-xs text-[#C9C0B4] mt-1"><span className="text-[#6E685F]">العنوان: </span>{c.address}</p>
        {c.last_login && <p className="text-[11px] text-[#6E685F] mt-2">آخر دخول: {new Date(c.last_login).toLocaleString()}</p>}
      </div>
      <div className="flex items-start gap-4">
        <MemberStats c={c} />
        <MemberAction c={c} onDelete={onDelete} onRestore={onRestore} />
      </div>
    </div>
  </div>
);

export function CustomersTab({ ctx }) {
  const { customers, memberSearch, setMemberSearch, deleteMember, restoreMember } = ctx;
  const list = filterMembers(customers, memberSearch);
  return (
    <div>
      <div className="flex items-end justify-between mb-8 gap-4 flex-wrap">
        <h1 className="serif text-3xl">الأعضاء · Members</h1>
        <div className="border border-[#262421] px-5 py-3 text-center" data-testid="members-count">
          <p className="text-[10px] uppercase tracking-widest text-[#8A857D]">عدد المشتركين</p>
          <p className="serif text-3xl text-[#C49A6C] mt-1">{customers.length}</p>
        </div>
      </div>
      {customers.length === 0 ? <Empty>لا يوجد أعضاء مسجّلين بعد. سيظهرون هنا بمجرد إنشاء حساب.</Empty> : (
        <>
          <input type="text" value={memberSearch} onChange={(e) => setMemberSearch(e.target.value)} data-testid="members-search" placeholder="ابحث بالاسم أو الإيميل أو الهاتف…"
            className="w-full bg-transparent border border-[#262421] focus:border-[#C49A6C] outline-none text-sm text-[#F2EBE1] px-4 py-3 mb-6 transition-colors" />
          {list.length === 0 ? <Empty>لا يوجد عضو مطابق لبحثك</Empty> : (
            <div className="space-y-4" data-testid="members-list">
              {list.map((c) => <MemberCard key={c.id} c={c} onDelete={deleteMember} onRestore={restoreMember} />)}
            </div>
          )}
        </>
      )}
    </div>
  );
}
